import type { TranslationSchema } from '../zh';
import common from './common';
import login from './login';
import register from './register';
import layout from './layout';
import invitation from './invitation';
import email from './email';
import message from './message';
import script from './script';
import chat from './chat';
import filter from './filter';
import workbench from './workbench';
import userCenter from './userCenter';
import talent from './talent';
import store from './store';
import creator from './creator';
import pricing from './pricing';

const vi: TranslationSchema = {
  common,
  login,
  register,
  layout,
  invitation,
  email,
  message,
  script,
  chat,
  filter,
  workbench,
  userCenter,
  talent,
  store,
  creator,
  pricing
};

export default vi;
